module.exports = __webpack_public_path__ + "assets/images/services/outdoor.jpg";